import { NavLink, Link } from "react-router-dom";

export default function SettingSideBar() {
  return (
    <>
      <div className="col-12">
        <div className="p-6 d-flex justify-content-between align-items-center d-md-none">
          <h3 className="fs-5 mb-0">Account Setting</h3>
          <button
            className="btn btn-outline-gray-400 text-muted d-md-none"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasAccount"
            aria-controls="offcanvasAccount"
          >
            <i className="fas fa-bars"></i>
          </button>
        </div>
      </div>

      <div className="col-lg-3 col-md-4 col-12 border-end  d-none d-md-block">
        <div className="pt-10 pe-lg-10">
          <ul className="nav flex-column nav-pills nav-pills-dark">
            <li className="nav-item">
              <NavLink
                to="/MyAccountOrder"
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="fas fa-shopping-bag me-2" />
                Your Orders
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="/MyAccountSetting"
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="fas fa-cog me-2" />
                Settings
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="/MyAccountAddress"
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="fas fa-map-marker-alt me-2" />
                Address
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="/MyAcconutPaymentMethod"
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="fas fa-credit-card me-2" />
                Payment Method
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="/MyAcconutNotification"
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="fas fa-bell me-2" />
                Notification
              </NavLink>
            </li>

            <li className="nav-item">
              <hr />
            </li>

            <li className="nav-item">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="fas fa-sign-out-alt me-2" />
                Log out
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}
